export const attachments = {
  uploadingADocumentWillTriggerAReferralMessageEnabled: true,
};
